import React from 'react';
import './UserCard.less';
import { Badge } from 'react-bootstrap';
import {getCurrentStyle} from "../helpers/passport";

export default function UserCard({
  displayName, role, job, tel, email,status,acceptedItem,passportStatus,item
}) {
  return (
    <div className="user-card">
      <section className="avatar">{displayName.charAt(0)}</section>
      <section>
        <p style={getCurrentStyle(passportStatus,item,acceptedItem,'displayName')} className="display-name">{displayName}</p>
        {job && <p className="job">{job}</p>}
        <section className="tel-email">
          {tel && <p className="tel">{tel}</p>}
          {email && <p className="e-mail">{email}</p>}
        </section>
        {role && <div className="role"><Badge bg="light" text="dark">{role}</Badge></div>}
      </section>
      {status && (
      <section>
        <div className="status">{status}</div>
      </section>
      )}
    </div>
  );
}
